import ReactGA from "react-ga4";

export const initializeGA = () => {
    if (process.env.REACT_APP_GA_ID) {
        ReactGA.initialize(process.env.REACT_APP_GA_ID, { testMode: process.env.NODE_ENV === "development" });
    }
};

export const trackPageView = () => ReactGA.send("pageview");
